@if(loading()){
<documents-form-skeleton></documents-form-skeleton>
} @else {
<form [formGroup]="saveForm" (submit)="false"
  class="flex flex-col gap-2 min-h-[calc(100dvh-4rem)] max-w-7xl mx-auto">

  @if (pendingSyncEntry()) {
  <div class="rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800">
    Guardado localmente, pendiente de sincronizar con el servidor.
  </div>
  }

  <section class="bg-white border border-slate-200 rounded-2xl shadow-sm">

    <div
      class="flex flex-row flex-wrap items-center justify-between px-4 py-2.5 bg-slate-50/50 border-b border-slate-100 gap-3">

      <div class="flex flex-row flex-wrap items-center gap-2 sm:gap-3">
        <div class="flex flex-col">
          <span class="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">Documento</span>
          <select formControlName="type" (change)="changeType()"
            class="bg-transparent border-none p-0 text-xl font-bold text-slate-800 focus:ring-0 cursor-pointer appearance-none pr-6 hover:text-blue-600 transition-colors">
            @if(isDocTypeAllowed('factura')) {
            <option value="factura">Factura</option>
            }
            @if(isDocTypeAllowed('albaran')) {
            <option value="albaran">Albarán</option>
            }
            @if(isDocTypeAllowed('devolucion')) {
            <option value="devolucion">Devolución</option>
            }
            @if(isDocTypeAllowed('presupuesto')) {
            <option value="presupuesto">Presupuesto</option>
            }
          </select>
        </div>
        <svg *ngIf="saveForm.get('hold_stock')?.value == 1" class="w-5 h-5 text-green-500" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        <input type="hidden" formControlName="hold_stock" name="hold_stock" value="">
        <div class="hidden sm:block h-7 w-px bg-slate-200 mx-1"></div>

        <div
          class="flex flex-wrap items-center gap-2 bg-white px-3 py-1.5 rounded-xl border border-slate-100 shadow-sm group cursor-pointer transition-all hover:border-blue-200 w-full sm:w-auto">

          <div class="text-left relative min-w-15">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">ID / Año</p>

            <p class="text-xs font-bold text-slate-700 group-hover:hidden transition-all">
              {{saveForm.get('id_by_company')?.value?.toString().padStart(4, '0')}} / {{saveForm.get('year')?.value}}
            </p>

            <div class="hidden group-hover:flex items-center gap-1 animate-in fade-in zoom-in duration-200">
              <span class="text-xs font-bold">
                {{saveForm.get('id_by_company')?.value?.toString().padStart(4,'0')}}
              </span>
              <span class="text-xs text-slate-300">/</span>
              <input type="number" formControlName="year"
                class="w-12 p-0 text-xs font-bold text-blue-600 border-none bg-blue-50 rounded focus:ring-0">
            </div>
          </div>

          <div class="text-left pl-1 relative min-w-20">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">Vendedor</p>

            <p class="text-xs font-bold text-slate-700 italic group-hover:hidden transition-all">
              {{showSeller()}}
            </p>

            <div class="hidden group-hover:block animate-in fade-in zoom-in duration-200">
              <select formControlName="user_id">
                @for (user of this.dropdowns().users; track $index) {
                <option [value]="user.id">
                  {{user.name}}
                </option>
                }
              </select>
            </div>
          </div>

          <div class="text-left pl-1 relative min-w-20">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">Oficina</p>

            <p class="text-xs font-bold text-slate-700 italic group-hover:hidden transition-all">
              {{showOfficeName()}}
            </p>

            <div class="hidden group-hover:block animate-in fade-in zoom-in duration-200">
              <select formControlName="office_id">
                @for (office of dropdowns().offices; track $index) {
                <option [value]="office.id">
                  {{office.name}}
                </option>
                }
              </select>
            </div>
          </div>

          @if(dropdowns().ibans.length > 0){
          <div class="text-left pl-1 relative min-w-24">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">IBAN</p>

            <p class="text-xs font-bold text-slate-700 italic group-hover:hidden transition-all">
              {{showIbanLabel()}}
            </p>

            <div class="hidden group-hover:block animate-in fade-in zoom-in duration-200">
              <select formControlName="iban">
                <option [value]="null">— Ninguno —</option>
                @for (item of dropdowns().ibans; track $index) {
                <option [value]="item.iban">
                  {{item.label}}
                </option>
                }
              </select>
            </div>
          </div>
          }

        </div>
      </div>

      <div class="flex items-center gap-2">
        @if(!isReadonly() && saveForm.get('type')?.value == 'factura') {
        <a routerLink="/sales/albaran/new"
          class="text-center px-4 py-2 bg-blue-50 text-blue-600 text-xs font-bold rounded-xl hover:bg-blue-600 hover:text-white transition-all">
          Crear venta de crédito
        </a>
        }
        @if(!isReadonly() && saveForm.get('type')?.value == 'presupuesto') {
        <button type="button" (click)="openAcceptBudgetModal()" [disabled]="saveForm.invalid || loading()"
          class="text-center px-4 py-2 bg-emerald-50 text-emerald-600 text-xs font-bold rounded-xl hover:bg-emerald-600 hover:text-white transition-all disabled:opacity-30">
          Aceptar presupuesto
        </button>
        }
      </div>
    </div>

    <div class="px-4 py-3">

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-row lg:items-end gap-3">
        <div class="flex-1">

          <custom-select [autofocus]="id == 0" label="Cliente" [formControlItem]="saveForm.controls['client_id']"
            [options]="dropdowns().clients" bindValue="id" bindLabel="name" bindSubLabel="nif" [isMultiple]="false"
            placeholder="Selecciona un cliente" (selectionChange)="changeClient()"
            [createComponent]="clientFormComponent" (itemCreated)="getDropdowns()">
          </custom-select>

        </div>

        <div [class.contrast-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected" class="flex-1">
          <custom-input label="Teléfono" type="text" [formControlItem]="saveForm.controls['phone']"></custom-input>
        </div>

        <div [class.contrast-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected" class="flex-1">
          <custom-input label="Fecha" type="date" [formControlItem]="saveForm.controls['date']"></custom-input>
        </div>

        <div class="flex-1" [class.contrast-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected">

          <custom-select label="Tarifa" [formControlItem]="saveForm.controls['tariff']" [options]="dropdowns().tariffs"
            placeholder="Selecciona una tarifa" bindValue="id" bindLabel="name" [isMultiple]="false">
          </custom-select>

        </div>
        <div class="flex-1 flex gap-1" [class.contrast-50]="!isClientSelected"
          [class.pointer-events-none]="!isClientSelected">

          <custom-select class="flex-1" label="Método de pago" [formControlItem]="saveForm.controls['pay_id']"
            [options]="dropdowns().payMethods" bindValue="id" bindLabel="name" [isMultiple]="false"
            placeholder="Selecciona un método de pago" (selectionChange)="changePayMethod()">
          </custom-select>

          @if (saveForm.get('invoice_split')?.value?.length > 0) {
          <button type="button"
            class="cursor-pointer mt-auto inline-flex p-1.5 items-center justify-center rounded-xl bg-slate-800 text-white hover:bg-slate-700 transition-colors"
            title="Mostrar desglose de cuotas" (click)="showSplitPayments()">

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4 h-auto">
              <path fill="currentColor"
                d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6.01 7 11 7s9.27-3.11 11-7c-1.73-3.89-6.01-7-11-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8.5c-1.93 0-3.5 1.57-3.5 3.5S10.07 15.5 12 15.5 15.5 13.93 15.5 12 13.93 8.5 12 8.5z" />
            </svg>

          </button>
          }
        </div>
      </div>

      @if (saveForm.get('invoice_split')?.value?.length > 0 && showSplitPay() == true) {
      <div [class.contrast-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected"
        class="pt-4 mt-3 border-t border-slate-100">
        <div class="flex items-center gap-2 mb-3">
          <div class="h-1.5 w-1.5 rounded-full bg-blue-500"></div>
          <h4 class="text-[11px] font-black text-slate-400 uppercase tracking-[0.2em]">Desglose de cuotas</h4>
        </div>

        <div class="flex flex-row flex-wrap gap-2" formArrayName="invoice_split">
          @for (item of invoiceSplitArray.controls; track $index) {
          <div [formGroupName]="$index"
            class="group/item flex items-center gap-3 px-3 py-2 bg-white border border-slate-100 rounded-xl hover:border-blue-200 transition-all shadow-sm">

            <div class="flex flex-col">
              <span class="text-[9px] font-bold text-slate-400">FECHA</span>
              <input type="date" formControlName="date"
                class="text-xs font-bold text-slate-700 bg-transparent border-none p-0 outline-none focus:text-blue-600">
            </div>

            <div class="h-6 w-px bg-slate-100"></div>

            <div class="flex flex-col w-12">
              <span class="text-[9px] font-bold text-slate-400 text-center">%</span>
              <input type="text" inputmode="decimal" decimalInput formControlName="percent"
                class="text-xs font-bold text-slate-700 bg-transparent border-none p-0 text-center outline-none">
            </div>

            <div class="flex flex-col items-end">
              <span class="text-[9px] font-bold text-slate-400">TOTAL</span>
              <span class="text-xs font-black text-slate-900">{{ item.get('total')?.value }}€</span>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </section>

  <section [class.contrast-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected"
    class="flex-1 flex flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
    <div [class.hidden]="isReadonly()" class="p-3 border-b border-slate-100 bg-white flex flex-col md:flex-row items-stretch md:items-center gap-3">
      <div class="relative flex-1 min-w-0">
        <span class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">🔍</span>
        <input type="text" #mainSearch (input)="filterProducts($any($event.target).value)" (focus)="openProductSearch()"
          (keydown.enter)="onSearchEnter($event, mainSearch)"
          placeholder="BUSCAR PRODUCTO POR NOMBRE O REFERENCIA..."
          class="w-full pl-12 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all uppercase tracking-wider">
        @if(showResults() && filteredProducts().length > 0) {
        <div
          class="absolute z-50 w-full mt-2 bg-white border border-slate-200 rounded-2xl shadow-xl max-h-60 overflow-y-auto p-2">
          @for(prod of filteredProducts(); track prod; let lastProd = $last) {
          <button type="button" (click)="selectProductFromSearch(prod, mainSearch)"
            (keydown.tab)="onSearchProductTab($any($event), lastProd)"
            class="w-full flex items-center justify-between p-3 hover:bg-blue-50 rounded-xl text-left transition-colors group">
            <div class="flex flex-col items-start gap-0.5">
              <span class="text-sm font-bold text-slate-700 uppercase">{{ prod.name }}</span>
              <div class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                <span class="text-[10px] font-bold text-slate-400">REF: {{prod.code}}</span>
                @for(tariff of dropdowns().tariffs; track tariff.id) {
                <span class="text-[10px] text-slate-400">{{ tariff.name }}: <span class="font-bold text-slate-600">{{ getPrice(prod, tariff.id) }}€</span></span>
                }
              </div>
            </div>
            <div class="flex flex-col items-end gap-0.5">
              <span class="text-sm font-black text-blue-600">{{ getPrice(prod) }}€</span>
              <span class="text-[10px] font-bold text-slate-400">Stock: {{ prod.stock }}</span>
            </div>
          </button>
          }
        </div>
        }
      </div>

      <button type="button" (click)="openProductCatalog()"
        class="w-full md:w-auto py-3 px-4 bg-slate-800 text-white hover:bg-slate-700 rounded-2xl font-bold text-xs tracking-widest transition-all uppercase whitespace-nowrap">
        Consulta de artículos
      </button>
    </div>

    @if(showProductCatalog()) {
    <app-custom-modal customTitle="Catálogo de productos" maxWidth="4xl" [hideFooter]="true" (closeFunction)="closeProductCatalog()">
      <div class="max-h-[60vh] overflow-auto">
        <table class="w-full min-w-140 text-left border-collapse">
          <thead class="sticky top-0 bg-slate-50/90 backdrop-blur-sm text-slate-500 z-10 border-b border-slate-100">
            <tr>
              <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest">Producto</th>
              @for(tariff of dropdowns().tariffs; track tariff.id) {
              <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right">{{ tariff.name }}</th>
              }
              <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right w-24">Stock</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50">
            @for(prod of catalogProducts; track prod.id) {
            <tr (click)="selectProductFromCatalog(prod)" class="hover:bg-blue-50 cursor-pointer transition-colors">
              <td class="px-3 py-2">
                <span class="block text-sm font-bold text-slate-700 uppercase leading-tight">{{ prod.name }}</span>
                <span class="block text-[10px] font-bold text-slate-400">REF: {{ prod.code }}</span>
              </td>
              @for(tariff of dropdowns().tariffs; track tariff.id) {
              <td class="px-3 py-2 text-right font-mono font-bold text-slate-600 text-sm">{{ getPrice(prod, tariff.id) }}€</td>
              }
              <td class="px-3 py-2 text-right font-mono font-bold text-slate-600 text-sm">{{ prod.stock }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </app-custom-modal>
    }

    <div class="flex-1 overflow-auto">
      <div
        class="hidden md:flex sticky top-0 bg-slate-50/90 backdrop-blur-sm text-slate-500 z-10 border-b border-slate-100 px-4 py-2.5 gap-3">
        <div class="flex-1 text-[10px] font-bold uppercase tracking-widest">Producto</div>
        <div class="w-24 shrink-0 text-center text-[10px] font-bold uppercase tracking-widest">Cant.</div>
        <div class="w-32 shrink-0 text-right text-[10px] font-bold uppercase tracking-widest">Precio Un.</div>
        <div class="w-32 shrink-0 text-right text-[10px] font-bold uppercase tracking-widest">Descuento</div>
        <div class="w-32 shrink-0 text-right text-[10px] font-bold uppercase tracking-widest">Total Sin IVA</div>
        <div class="w-32 shrink-0 text-right text-[10px] font-bold uppercase tracking-widest">Total</div>
        <div class="w-10 shrink-0"></div>
      </div>

      <div formArrayName="items" class="divide-y divide-slate-50">
        @for (item of itemControls; track item; let i = $index; let last = $last) {

        <div [formGroupName]="i" [class.bg-yellow-100]="!item.get('product_id')?.value"
          class="relative flex flex-col md:flex-row md:items-center gap-2 md:gap-3 px-4 py-3 md:py-2">

          @let p = getProductInfo(item.get('product_id')?.value);
          <div class="flex-1 min-w-0 pr-8 md:pr-0 flex flex-col items-start gap-0.5">

            <div class="group">
              <span
                class="group-hover:hidden group-focus-within:hidden text-sm font-bold text-slate-700 uppercase leading-tight">
                {{ item.get('name')?.value || 'Item Manual' }}
              </span>

              <input type="text" formControlName="name" tabindex="-1"
                class="hidden group-hover:block group-focus-within:block w-full py-1.5 bg-slate-50 border border-slate-200 rounded-lg font-bold text-slate-700 text-sm outline-none">
            </div>

            @if(p?.special_measures){
            <div class="flex flex-wrap gap-1 items-center">
              @for (m of item.get('special_measures')?.value; track $index) {
              <span class="text-[9px] font-mono bg-slate-100 text-slate-500 px-1.5 rounded border border-slate-200">
                {{m.q}} x {{m.h}}x{{m.w}}x{{m.t}}
              </span>
              }
              @if(!isReadonly()) {
              <button type="button" [attr.tabindex]="(i * 10) + 2"
                (click)="openMeasures(i, item.get('special_measures')?.value, p.special_measures)"
                class="text-[9px] font-bold text-blue-500 hover:underline ml-1">Editar medidas</button>
              }
            </div>
            }
          </div>

          <div class="grid grid-cols-2 md:contents gap-2">
            <div class="md:w-24 md:shrink-0">
              <span class="md:hidden block text-[9px] font-bold text-slate-400 uppercase mb-0.5">Cant.</span>
              <input #productListQuantity type="text" inputmode="decimal" decimalInput [decimals]="3" formControlName="quantity" [attr.tabindex]="(i * 10) + 1"
                class="w-full py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-center font-bold text-slate-700 text-sm outline-none">
            </div>

            <div class="md:w-32 md:shrink-0">
              <span class="md:hidden block text-[9px] font-bold text-slate-400 uppercase mb-0.5">Precio Un.</span>
              <span class="flex items-center">
                <input type="text" inputmode="decimal" decimalInput formControlName="price" [attr.tabindex]="(i * 10) + 3"
                  class="w-full py-1.5 bg-transparent md:text-right font-bold text-sm text-slate-600 outline-none">
                €
              </span>
            </div>

            <div class="md:w-32 md:shrink-0">
              <span class="md:hidden block text-[9px] font-bold text-slate-400 uppercase mb-0.5">Descuento</span>
              <span class="flex items-center">
                <input type="number" formControlName="discount" [attr.tabindex]="(i * 10) + 4"
                  (keydown.tab)="onDiscountTab($any($event), last, mainSearch)"
                  class="w-full py-1.5 bg-transparent md:text-right font-bold text-sm text-slate-600 outline-none"> %
              </span>
            </div>

            <div class="hidden md:block md:w-32 md:shrink-0 text-right font-mono font-bold text-slate-500 text-sm">
              {{ getAndCalculateWithOutTax(item) }}€
            </div>

            <div class="md:w-32 md:shrink-0 text-right">
              <span class="md:hidden block text-[9px] font-bold text-slate-400 uppercase mb-0.5">Total</span>
              <span class="font-mono font-black text-slate-800 text-sm">{{ getAndCalculateWithTax(item) }}€</span>
            </div>
          </div>

          @if(!isReadonly()) {
          <button type="button" (click)="removeItem(i)" tabindex="-1"
            class="absolute top-2 right-2 md:static md:w-10 md:shrink-0 text-slate-300 hover:text-red-500 outline-none">✕</button>
          }
        </div>

        }
      </div>
    </div>
  </section>

  <section [class.contrast-50]="!isClientSelected" [class.pointer-events-none]="!isClientSelected"
    class="sticky bottom-0 z-20 bg-slate-900 rounded-2xl p-3 text-white shadow-2xl shadow-slate-900/40 border border-white/5">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3">

      <div class="flex items-center gap-3 md:gap-4 flex-wrap">
        <div class="flex flex-col">
          <span class="text-slate-500 font-bold uppercase text-[9px] tracking-widest">Subtotal</span>
          <span class="text-xl font-bold italic">{{ saveForm.get('subtotal')?.value }}€</span>
        </div>
        <div class="flex items-center bg-white/5 p-1.5 rounded-2xl border border-white/10 gap-3">
          <div class="flex bg-slate-800 p-1 rounded-xl border border-white/5">
            <label class="cursor-pointer">
              <input type="radio" [value]="0" formControlName="discount_absolute_bool" class="peer hidden">
              <span
                class="px-3 py-1 rounded-lg text-[10px] font-bold text-slate-400 peer-checked:bg-blue-600 peer-checked:text-white transition-all">%</span>
            </label>
            <label class="cursor-pointer">
              <input type="radio" [value]="1" formControlName="discount_absolute_bool" class="peer hidden">
              <span
                class="px-3 py-1 rounded-lg text-[10px] font-bold text-slate-400 peer-checked:bg-blue-600 peer-checked:text-white transition-all">€</span>
            </label>
          </div>
          <input type="text" inputmode="decimal" decimalInput formControlName="discount"
            class="w-16 bg-transparent border-none text-right font-black text-white focus:ring-0 p-0 text-xl"
            placeholder="0">
        </div>
        @if(saveForm.get('type')?.value === 'albaran'){
        <label for="dailly_invoice_bool" class="text-[10px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer">¿Facturar albarán diario?</label>
        <input type="checkbox" id="dailly_invoice_bool" formControlName="dailly_invoice_bool"
          class="w-5 h-5 text-black border-2 border-black rounded focus:ring-black accent-black cursor-pointer">
        }
      </div>

      <div class="flex items-center justify-between md:justify-end gap-3 md:gap-4 flex-wrap">
        <div class="flex items-center gap-3">
          <span
            class="text-[10px] font-bold text-slate-500 uppercase tracking-tighter leading-tight w-min text-right">Total</span>
          <div class="flex items-baseline">
            <span class="text-4xl md:text-5xl font-black tracking-tighter text-blue-400">
              {{ saveForm.get('total')?.value }}
            </span>
            <span class="text-lg ml-1 text-slate-500 font-bold">€</span>
          </div>
        </div>

        @if(!isReadonly()) {
        <div class="flex items-center gap-2">
          <button (click)="saveEntity()" type="submit" [disabled]="saveForm.invalid || loading()"
            class="flex-1 md:flex-none md:w-36 py-3 bg-blue-600 text-white hover:bg-blue-500 rounded-xl font-bold text-xs tracking-widest transition-all uppercase shadow-lg shadow-blue-900/20 disabled:opacity-30">
            Guardar
          </button>
          <button (click)="saveAndPrint()" type="button" [disabled]="saveForm.invalid || loading()"
            class="shrink-0 p-3 bg-slate-800 text-slate-300 hover:text-white hover:bg-slate-700 rounded-xl transition-all border border-slate-700">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
          </button>
          @if(saveForm.get('type')?.value === 'presupuesto') {
          <button (click)="saveEntity(true)" type="button" [disabled]="saveForm.invalid || loading()" title="Guardar como borrador"
            class="shrink-0 p-3 bg-slate-800 text-slate-300 hover:text-white hover:bg-slate-700 rounded-xl transition-all border border-slate-700">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          }
        </div>
        }
      </div>
    </div>
  </section>

</form>
}

@if(editMeasures()){
<document-special-measures-form [specialMeasures]="specialMeasures()" [defaultMeasures]="defaultMeasures()"
  (closeFunction)="toggleEditMeasures()" (acceptFunction)="acceptMeasures($event)"></document-special-measures-form>
}

@if(showAcceptBudgetModal()) {
<document-accept-budget-modal (closeFunction)="closeAcceptBudgetModal()"
  (acceptFunction)="acceptBudget($event.type, $event.date)">
</document-accept-budget-modal>
}